// Central site constants
export const SITE = {
  name: "RK Jain",
  tagline: "Pumping & Agricultural Solutions",
  // Primary contact phone (owner)
  phoneDisplay: "+91 99228 40079",
  phoneRaw: "+919922840079",
  // Secondary contact phone (this is also the WhatsApp number)
  phoneDisplayAlt: "+91 86686 69596",
  phoneRawAlt: "+918668669596",
  whatsappNumber: "918668669596",
  email: "ratneshkothari5555@gmail.com",
  emailAlt: "kotharinayan60@gmail.com",
  addressLines: [
    "Kinetic Chowk, Chayya Nagar",
    "Under Pune Railway Bridge",
    "Ahilyanagar, Maharashtra",
    "PIN: 414001",
  ],
  established: 1984,
  logo:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/7zq2zx55_WhatsApp%20Image%202026-07-26%20at%2010.55.59%20PM.jpeg",
  // Social media
  social: {
    instagram:
      "https://www.instagram.com/newpritamagency?igsh=MW5pZHlmbHB5ZDhhaQ%3D%3D&utm_source=qr",
    youtube: "https://youtube.com/@newpritamagency09?si=WvDBdntwNcYGeDkC",
    facebook: "https://www.facebook.com/share/1E7mCX4ZSx/",
  },
};

// Years of experience, auto-calculated from the founding year.
export const yearsSince = () => new Date().getFullYear() - SITE.established;

export const WHATSAPP_MESSAGE =
  "Hello RK Jain,\nI am interested in your products. Please share more details.";

export function whatsappUrl(customMessage) {
  const msg = customMessage || WHATSAPP_MESSAGE;
  return `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(msg)}`;
}

export function openWhatsApp(customMessage) {
  window.open(whatsappUrl(customMessage), "_blank", "noopener,noreferrer");
}

export const NAV_LINKS = [
  { key: "home", to: "/" },
  { key: "about", to: "/about" },
  { key: "products", to: "/products" },
  { key: "catalogue", to: "/catalogue" },
  { key: "why", to: "/why-rk-jain" },
  { key: "enquiry", to: "/enquiry" },
  { key: "contact", to: "/contact" },
];

// Full RK Jain product catalogue (uploaded PDF)
export const CATALOGUE_PDF =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_rk-jain-premium/artifacts/m8ckxuop_DocScanner%2026-Jul-2026%2010-42%20PM.pdf";
